<template>
  <v-container class="pt-6">
    <v-row>
      <v-col cols="12">
        <v-card class="mx-auto transparent elevation-0">
          <v-card-text>
            <div class="mb-0 font-weight-bold text-h5 textPrimary--text text-center">
              ACCESOS
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Grupos asignados -->
      <AccesosLista :accesos="accesos"/>
    </v-row>

    <v-speed-dial
      bottom
      right
      fixed
      class="mb-12"
    >
      <template v-slot:activator>
        <v-btn
          color="blue darken-2"
          dark
          fab
          @click="getAsistenciaUsuario()"
        >
          <v-icon>
            mdi-refresh
          </v-icon>
        </v-btn>
      </template>
    </v-speed-dial>

    <!-- Alertas -->
    <Alerta         v-if="respuestaAlerta"         :parametros="parametros"/>
    <Loader         v-if="cargar"                  :loader="loader"/>
    <SinAcceso      v-if="alertaAcceso.estatus"    :alertaAcceso="alertaAcceso" @click="salirLogin()"/>

  </v-container>
</template>
<script>
  // Importar lebrerías
  import { mapGetters, mapActions } from 'vuex'
  const  base64 = require('base-64');
  import { Clipboard } from '@capacitor/clipboard';
  import { Share } from '@capacitor/share';

  // Componentes
  import Alerta        from '@/components/alertas/Alerta.vue'
  import Loader        from '@/components/alertas/Loader.vue'
  import AccesosLista  from '@/components/accesos/AccesosLista.vue'


  export default {
    components:{
      Alerta,
      Loader,
      AccesosLista
    },

    data () {
      return {
        parametros:{
          dialogError: false,
          mensaje: '',
          color: ''
        },

        visibleEncuesta: false,
        accesoExci:false,

        accesos:[],

        respuestaAlerta:false,
        cargar:false,
        loader:false,
        alertaAcceso:{
          estatus: false,
        },
      }
    },

    computed:{
      ...mapGetters( 'login', [ 'getGrupo', 'getUsuarioLMS', 'getRecursosGrupoUsuario', 'getGrupos', 'getEscuela' ]),
    },

    async created ( ){
      await this.getAsistenciaUsuario()
    },

    methods:{
      ...mapActions( 'login', [ 'abrirGrupo', 'grabarGruposUsuario', 'salirLogin' ]),

      getAsistenciaUsuario ( ) {
        this.cargar  = true
        this.accesos = []
        // Hacemos la petición
        this.$http.get('validar.entradas').then( response => {
          // Guardamos los grupos
          this.accesos = response.body
          this.cargar = false
        }).catch( error =>{
          this.validarError ( error )
        }).finally(()=>{ this.cargar = false })
      },

      validarError ( value ) {
        this.cargar = false 
        if( value.status == 400 || value.status == 500){
          this.parametros.mensaje      = value.body.message
          this.parametros.dialogError  = true 
          this.parametros.color        = '#FF2C2C'
          this.respuestaAlerta = true 
        }
      },

    }
  }
</script>

